import { useState } from 'react'
import styled from 'styled-components'
import { AnimatePresence } from 'framer-motion'
import { useSelector } from 'react-redux'

import useProductDetail from 'hooks/product/useProductDetail'
import usePurchaseModal from 'hooks/product/usePurchaseModal'

import ProductInfoSection from 'components/presenters/commerce/product/ProductInfoSection/ProductInfoSection'
import ProductInfoContent from 'components/presenters/commerce/product/ProductInfoContent'
import ProductBanner from 'components/presenters/commerce/product/ProductBanner'
import ProductDetailContentBlock from 'components/presenters/commerce/product/ProductDetailContentBlock'
import VendorProfileHeader from 'components/presenters/commerce/product/VendorProfileHeader/VendorProfileHeader'
import ProductHeader from 'components/presenters/commerce/product/ProductHeader'
import PackageServiceInfo from 'components/presenters/commerce/product/PackageServiceInfo'
import StoreMoreBtn from 'components/presenters/commerce/product/StoreMoreBtn'
import ProductInfoTab from 'components/presenters/commerce/product/ProductInfoTab'
import ProductDescription from 'components/presenters/commerce/product/ProductDescription'
import CommerceTutorial from 'components/presenters/commerce/product/CommerceTutorial'
import RefundCondition from 'components/presenters/commerce/product/RefundCondition'
import ProductDetailFooter from 'components/presenters/commerce/product/ProductDetailFooter'
import PurchaseBtn from 'components/presenters/commerce/product/PurchaseBtn'
import PurchaseModal from 'components/presenters/commerce/product/PurchaseModal'

import SplitterBar from 'components/presenters/common/SplitterBar'

import LoadingAnimation from 'components/presenters/common/LoadingAnimation'

export default function ProductDetailContainer() {
  const {
    productInfo,
    shippingInfo,
    vendorInfo,
    reviewUrlInfo,
    scrollRef,
    currTab,
    handleScroll,
    handleChangeTab,
    changeCurrTabByScroll,
    handleClickPolicyBtn,
    handleClickVendorBtn,
  } = useProductDetail()
  const {
    purchaseModalVisible,
    purchaseModalType,
    handleClickPurchaseBtn,
    handleClickCloseBtn,
    whiteboxRef,
    productVariants,
    handleSelectOption,
    selectOptions,
    totalPrice,
    handleOptionDelete,
    isValid,
    handleQuantityIncrease,
    handleQuantityDecrease,
    handleClickPurchase,
  } = usePurchaseModal({
    productInfo: productInfo,
  })
  const [isReviewIframeLoaded, setIsReviewIframeLoaded] = useState(false)

  const userInfo = useSelector((state) => {
    return state.userInfo
  })

  return (
    <>
      <ProductInfoSection>
        <ProductInfoContent scrollRef={scrollRef} onScroll={handleScroll}>
          <ProductBanner
            bannerImg={productInfo.banner_img}
            stock={selectOptions.length > 0 ? selectOptions[0].stock : undefined}
          />
          <ProductDetailContentBlock>
            <VendorProfileHeader
              vendorProfileImg={vendorInfo.profile_img}
              companyName={vendorInfo.company_name}
            />
            <ProductHeader
              title={productInfo.title}
              discountPercent={productInfo.discount_percent}
              lowestPrice={productInfo.lowest_price}
              lowestChallengePrice={productInfo.lowest_challenge_price}
              period={productInfo.challenge_info.period}
              minAuth={productInfo.challenge_info.min_auth}
            />
            <SplitterBar
              margin={`calc(100vw * (22 / 375)) 0 calc(100vw * (26 / 375)) 0`}
              height={`1px`}
              color={'#EFEFEF'}
            />
            <PackageServiceInfo
              price={shippingInfo.price}
              jejuPrice={shippingInfo.jeju_price}
              otherPrice={shippingInfo.other_price}
              shippingName={shippingInfo.name}
            />
            <SplitterBar
              margin={`calc(100vw * (19 / 375)) 0 calc(100vw * (14 / 375)) 0`}
              height={`1px`}
              color={'#EFEFEF'}
            />
            {/* <StoreMoreBtn
              profileImg={vendorInfo.profile_img}
              brandName={vendorInfo.name}
              vendorStoreLink={vendorInfo.vendor_store_link}
            /> */}

            {userInfo.deviceType !== 'iOS' && reviewUrlInfo.review_url && (
              <ReviewContainer hasPhotoReview={reviewUrlInfo.is_photo_review}>
                {!isReviewIframeLoaded && (
                  <ReviewLoadingWrapper>
                    <div
                      style={{
                        width: 'calc(100vw * (35 / 375))',
                        height: 'calc(100vw * (35 / 375))',
                        marginBottom: 'calc(100vw * (15 / 375))',
                      }}
                    >
                      <LoadingAnimation />
                    </div>
                    <ReviewLoadingText>리뷰 불러오는 중</ReviewLoadingText>
                  </ReviewLoadingWrapper>
                )}

                <ReviewWrapper hasPhotoReview={reviewUrlInfo.is_photo_review}>
                  <ReviewIframe
                    title="review"
                    src={reviewUrlInfo.review_url}
                    scrolling="no"
                    width="100%"
                    height="100%"
                    onLoad={() => {
                      if (!scrollRef.current) {
                        return
                      }

                      setIsReviewIframeLoaded(true)
                    }}
                    isReviewIframeLoaded={isReviewIframeLoaded}
                  />
                </ReviewWrapper>
              </ReviewContainer>
            )}

            <ReviewMore
              onClick={() => {
                window.open(reviewUrlInfo.review_more_url, '_blank')
              }}
            >
              리뷰 보러 가기
            </ReviewMore>

            <ProductInfoTab onChageTab={handleChangeTab} currTab={currTab} />
            <ProductDescription
              descriptions={productInfo.descriptions}
              changeCurrTabByScroll={changeCurrTabByScroll}
            />
            <CommerceTutorial
              proofList={productInfo.sample_proof}
              changeCurrTabByScroll={changeCurrTabByScroll}
            />
            <RefundCondition
              minAuth={productInfo.challenge_info.min_auth}
              period={productInfo.challenge_info.period}
            />
            <ProductDetailFooter
              changeCurrTabByScroll={changeCurrTabByScroll}
              onClickPolicyBtn={handleClickPolicyBtn}
              onClickVendorBtn={handleClickVendorBtn}
            />
          </ProductDetailContentBlock>
        </ProductInfoContent>
        <PurchaseBtn
          lowestPrice={productInfo.lowest_price}
          lowestChallengePrice={productInfo.lowest_challenge_price}
          onBtnClick={handleClickPurchaseBtn}
          isAlreadyParticipated={productInfo.is_already_participated}
        />
      </ProductInfoSection>

      <AnimatePresence>
        {purchaseModalVisible && (
          <PurchaseModal
            productTitle={productInfo.title}
            whiteboxRef={whiteboxRef}
            type={purchaseModalType}
            onClose={handleClickCloseBtn}
            isShowOption={!!(productInfo.type !== 'normal')}
            productVariants={productVariants}
            onSelectOption={handleSelectOption}
            onOptionDelete={handleOptionDelete}
            selectOptions={selectOptions}
            totalPrice={totalPrice}
            lowestPrice={productInfo.lowest_price}
            lowestChallengePrice={productInfo.lowest_challenge_price}
            isValid={isValid}
            onQuantityIncrease={handleQuantityIncrease}
            onQuantityDecrease={handleQuantityDecrease}
            onClickPurchase={handleClickPurchase}
          />
        )}
      </AnimatePresence>
    </>
  )
}

const ReviewContainer = styled.div`
  overflow: hidden;
  height: ${({ hasPhotoReview }) => (hasPhotoReview ? 368 : 209)}px;
  margin-bottom: 10px;
`

const ReviewWrapper = styled.div`
  height: ${({ hasPhotoReview }) => (hasPhotoReview ? 436 : 273)}px;
  position: relative;
  top: -68px;
`

const ReviewIframe = styled.iframe`
  overflow: hidden;
  ${({ isReviewIframeLoaded }) =>
    isReviewIframeLoaded
      ? null
      : `
      position: fixed;
      top: -1000px;
      visibility: hidden;
    `}
`

const ReviewMore = styled.div`
  width: 100%;
  height: calc(100vw * (45 / 375));
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #c6c6c6;
  border-radius: calc(100vw * (5 / 375));
  font-weight: 600;
  font-size: calc(100vw * (16 / 375));
  line-height: calc(100vw * (19 / 375));
  margin-bottom: calc(100vw * (20 / 375));
`

const ReviewLoadingWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const ReviewLoadingText = styled.div`
  font-weight: 500;
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (17 / 375));
`
